import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const AdminPage = () => {
  const { token, admin, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-xs tracking-[0.3em] text-white/50">LOADING...</div>
      </div>
    );
  }
  if (!token || !admin) return <AdminLogin />;
  return <AdminDashboard />;
};

export default AdminPage;
